"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _ModalHeader2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _jsxRuntime = require("react/jsx-runtime");
var _ModalHeader, _FormattedMessage, _FormattedMessage2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NoAccountFound = _ref => {
  let {
    onContinueClick,
    isLoading,
    onBackClick
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [_ModalHeader || (_ModalHeader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader2.default, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.sign_in_with_apple.no_account_found"
      }),
      description: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.sign_in_with_apple.no_account_found.description"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        spacing: "400",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          fullWidth: true,
          loading: isLoading,
          onClick: onContinueClick,
          title: isLoading ? intl.formatMessage({
            id: "common.loading"
          }) : undefined,
          children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.ok"
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          fullWidth: true,
          type: "secondary",
          onClick: onBackClick,
          children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.back"
          }))
        })]
      })
    })]
  });
};
var _default = exports.default = NoAccountFound;